import './horizontraining/style';
import FormStructure from './horizontraining/form_structure';

export default FormStructure;